import { createFileRoute } from '@tanstack/react-router';
import {
  emailValidationLoader,
  redirectIfVerified,
} from 'router/loaders/emailValidation';
import { createSignupOnVerified } from 'router/loaders/onVerified/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';

import { PageSkeleton } from 'components/templates/PageSkeleton';

export const Route = createFileRoute('/_signup/email-validation')({
  pendingComponent: PageSkeleton,
  head: headSignupSubRoute,
  beforeLoad: async ({ context, location, preload, cause }) => {
    const { queryVariables } = await beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validation: {
        validate: ({ lead }) => !!lead?.id,
        redirectTarget: location.state.previousLocation?.href ?? '/',
      },
    });

    // Where the Partner goes once the email is verified is the signup's logic,
    // so the signup supplies it to the OTP redirect and page.
    // https://tanstack.com/router/latest/docs/guide/router-context
    const email = queryVariables.businessEmail;
    const onVerified = createSignupOnVerified({
      context,
      leadId: queryVariables.leadId,
      email,
      previousLocation: location.state.previousLocation,
    });

    await redirectIfVerified({
      queryClient: context.queryClient,
      email,
      onVerified,
      cause,
      route: Route,
    });

    return { email, onVerified };
  },
  loader: args => emailValidationLoader(args),
});
